import angular from 'angular'

import { RestrictedAccessRoutesConfig } from './routes-restrict-access.route'

angular.module('webregister.routes').config(RestrictedAccessRoutesConfig)
